class VueWechatAuthPlugin {
  constructor() {
    this.WxKey = null
    this.income = null
    this.parameter = null
    this.redirect_url = null
  }

  static makeState() {
    return (
      Math.random()
        .toString(36)
        .substring(2, 15) +
            Math.random()
              .toString(36)
              .substring(2, 15)
    )
  }

  get state() {
    return localStorage.getItem('wechat_auth:state')
  }

  set state(state) {
    localStorage.setItem('wechat_auth:state', state)
  }

  get authUrl() {
    if (this.appid === null) {
      throw new Error('appid must not be null')
    }
    if (this.redirect_url === null) {
      throw new Error('redirect url must not be null')
    }
    this.state = VueWechatAuthPlugin.makeState()
    const url = `https://api.crm.yes-go.cn/wechat/Base/authorize?${
      this.parameter
    }&url=${this.redirect_url}`
    return url
  }
}

const vueWechatAuthPlugin = new VueWechatAuthPlugin()

// if (typeof window !== 'undefined' && window.Vue) {
//   window.Vue.use(VueWechatAuthPlugin)
// }

export default vueWechatAuthPlugin
